const currentDateObject = () => {
  let newDate = new Date();
  return {
    d: newDate.getDate(),
    m: newDate.getMonth(),
    y: newDate.getFullYear()
  };
};

export default currentDateObject();